import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Container } from '@mui/material';
import { IncidentPlayerList } from './incidentsPlayerList/incidentPlayerList';
import { MobileHeader } from '../../components/mobileHeader/mobileHeader';
import { di } from '../../state/inversify.config';
import { getRouteByAccountType } from '../../routes/getRouteByAccountType';
import { PlayerIncidentList } from './incidentsList.interface';
import { useQuerySync } from '../../state/queryParams/useQuerySync';
import { IncidentListQueryService } from './incidentList.queryParam.service';
import { Banner } from '../../components/banner/banner';
import { LoggedInUser } from '../../state/helperServices/auth/auth.interfaces';

interface IncidentListProps {
  user: LoggedInUser;
  openIncidents: PlayerIncidentList[];
  closedIncidents: PlayerIncidentList[];
}

export const IncidentsListDumb = ({
  user,
  openIncidents,
  closedIncidents,
}: IncidentListProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const incidentListQueryService = di.get<IncidentListQueryService>(
    IncidentListQueryService,
  );

  useQuerySync(incidentListQueryService);

  const handleOnSelectIncident = (playerId: string, incidentId: string) => {
    navigate(
      `/${getRouteByAccountType(
        user?.accountType,
      )}/view-incident?selectedPlayerId=${playerId}&selectedIncidentId=${incidentId}`,
    );
  };

  return (
    <Container>
      <MobileHeader />
      <Typography
        id="incident-title"
        variant="h5"
        component="h5"
        fontWeight="bold"
      >
        {t('incident.INCIDENT_LIST_PAGE_TITLE')}
      </Typography>

      <Typography
        id="incident-title"
        variant="h6"
        component="h6"
        sx={{ my: 1 }}
      >
        {t('incident.INCIDENT_LIST_OPEN_INCIDENTS_TITLE')}
      </Typography>
      <Grid container spacing={2}>
        {openIncidents?.length > 0 ? (
          openIncidents?.map((openIncident: PlayerIncidentList) => {
            return (
              <Grid
                key={openIncident.id}
                item
                xs={12}
                sm={12}
                md={4}
                onClick={() =>
                  handleOnSelectIncident(openIncident.playerId, openIncident.id)
                }
              >
                <IncidentPlayerList incident={openIncident} />
              </Grid>
            );
          })
        ) : (
          <Grid item xs={8} sm={8} md={8}>
            <Banner
              severity="info"
              elevation={2}
              title={t('incident.INCIDENT_LIST_NO_OPEN_INCIDENTS')}
            />
          </Grid>
        )}
      </Grid>

      <Typography
        id="incident-title"
        variant="h6"
        component="h6"
        sx={{ my: 1 }}
      >
        {t('incident.INCIDENT_LIST_CLOSED_INCIDENTS_TITLE')}
      </Typography>
      <Grid container spacing={2}>
        {closedIncidents?.length > 0 ? (
          closedIncidents.map((closedIncident: PlayerIncidentList) => {
            return (
              <Grid
                key={closedIncident.id}
                item
                xs={12}
                sm={12}
                md={4}
                onClick={() =>
                  handleOnSelectIncident(
                    closedIncident.playerId,
                    closedIncident.id,
                  )
                }
              >
                <IncidentPlayerList incident={closedIncident} />
              </Grid>
            );
          })
        ) : (
          <Grid item xs={8} sm={8} md={8}>
            <Banner
              severity="info"
              elevation={2}
              title={t('incident.INCIDENT_LIST_NO_CLOSED_INCIDENTS')}
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
};
